import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { COLORS } from "@/packages/theme/tokens";
import { Box, chakra, Flex, Grid } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import { type RoomSlideProps } from "./roomSlides.type";

export const RoomSlides = ({ imgList, inView }: RoomSlideProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const carouselRef = useRef<Carousel>(null);
    const containerPCHeight = isLaptop ? "508px" : "792px";
    const WrapperPCPaddingRight = isLaptop ? "88px" : "256px";

    const handlePrev = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem - 1);
    };
    const handleNext = () => {
        carouselRef.current?.moveTo(carouselRef.current.state.selectedItem + 1);
    };
    const groupedImgList = isMobile
        ? imgList.reduce(
              (result, img, index) => {
                  if (index % 2 === 0) result.push([img]);
                  else result[result.length - 1].push(img);
                  return result;
              },
              [] as { imgUrl: string }[][],
          )
        : imgList.map((img) => [img]);

    return (
        <Box
            position={isMobile ? "relative" : "absolute"}
            w="100%"
            h={isMobile ? "100%" : "auto"}
            top={isMobile ? "auto" : "50%"}
            left={isMobile ? "auto" : "50%"}
            zIndex="1"
            transform={isMobile ? "none" : "translate(-50%, -50%)"}
            paddingRight={isMobile ? "0" : WrapperPCPaddingRight}
        >
            <MotionSlideContainer
                position="relative"
                // maxW={isLaptop ? "1192px" : "1664px"}
                display={isMobile ? "flex" : "block"}
                flexDir="column"
                rowGap="16px"
                height={isMobile ? "100%" : containerPCHeight}
                w="100%"
                p={isMobile ? "0 24px" : "0"}
                borderRightRadius="16px"
                initial={{ width: "10%" }}
                animate={inView ? { width: "100%", transition: { duration: 0.6 } } : {}}
            >
                <CustomCarousel
                    ref={carouselRef}
                    infiniteLoop
                    showIndicators={false}
                    showStatus={false}
                    showThumbs={false}
                    showArrows={false}
                >
                    {groupedImgList.map((group) => (
                        <Grid
                            key={Math.random()}
                            gridTemplateRows={isMobile ? "repeat(2,1fr)" : "repeat(1,1fr)"}
                            rowGap="16px"
                            w="100%"
                            // maxW={isLaptop ? "1192px" : "1664px"}
                            // maxHeight={isMobile ? "552px" : "none"}
                            height={isMobile ? "100%" : containerPCHeight}
                        >
                            {group.map((img) => (
                                <Box
                                    key={img.imgUrl}
                                    flex="1"
                                    background={`url(${img.imgUrl}) no-repeat center/cover`}
                                    borderRadius={isMobile ? "16px" : "0"}
                                />
                            ))}
                        </Grid>
                    ))}
                </CustomCarousel>
                <Flex
                    position={isMobile ? "relative" : "absolute"}
                    zIndex="3"
                    columnGap="16px"
                    right={isMobile ? "auto" : "80px"}
                    bottom={isMobile ? "auto" : "40px"}
                    w={isMobile ? "100%" : "auto"}
                    justifyContent={isMobile ? "flex-end" : "flex-start"}
                >
                    <CustomControlButton iconNamed="navigate_before" onClick={handlePrev} />
                    <CustomControlButton iconNamed="navigate_next" onClick={handleNext} />
                </Flex>
            </MotionSlideContainer>
        </Box>
    );
};
const MotionSlideContainer = chakra(motion.div);

const CustomCarousel = styled(Carousel)`
    @media (max-width: 768px) {
        height: 100%;
    }
    & > .carousel-slider {
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;

        @media (max-width: 768px) {
            height: 100%;

            & .slider-wrapper {
                height: 100% !important;
            }
            & ul {
                height: 100%;
                & li {
                    height: 100%;
                }
            }
        }
    }
`;

const CustomControlButton = styled(Button)`
    width: 48px;
    border: 1px solid ${COLORS.white};
    border-radius: 50%;
    color: ${COLORS.white};
`;
